import type { KnightProfileData, Ruleset } from "./Ruleset";

export class KnightProfile {
  ruleset: Ruleset;
  data: KnightProfileData;

  constructor(ruleset: Ruleset, data: KnightProfileData) {
    this.ruleset = ruleset;
    this.data = data;
  }

  get id() {
    return this.data.id;
  }

  get name() {
    return this.data.name;
  }

  get damageLimit() {
    return this.data.damageLimit;
  }

  get momentumLimit() {
    return 3;
  }
}
